import { cn } from "@/utils/cn";

/**
 * SunIcon for light mode representation
 */
export const SunIcon = ({ className }: { className?: string }) => (
  <svg
    aria-label="Light mode"
    className={cn(className, "text-current")}
    fill="none"
    role="img"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    style={{ shapeRendering: "geometricPrecision" }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="5" />
    <line x1="12" x2="12" y1="1" y2="3" />
    <line x1="12" x2="12" y1="21" y2="23" />
    <line x1="4.22" x2="5.64" y1="4.22" y2="5.64" />
    <line x1="18.36" x2="19.78" y1="18.36" y2="19.78" />
    <line x1="1" x2="3" y1="12" y2="12" />
    <line x1="21" x2="23" y1="12" y2="12" />
    <line x1="4.22" x2="5.64" y1="19.78" y2="18.36" />
    <line x1="18.36" x2="19.78" y1="5.64" y2="4.22" />
  </svg>
);

/**
 * MoonIcon for dark mode representation
 */
export const MoonIcon = ({ className }: { className?: string }) => (
  <svg
    aria-label="Dark mode"
    className={cn(className, "text-current")}
    fill="none"
    role="img"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    style={{ shapeRendering: "geometricPrecision" }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

/**
 * ComputerIcon for system preference representation
 */
export const ComputerIcon = ({ className }: { className?: string }) => (
  <svg
    aria-label="System mode"
    className={cn(className, "text-current")}
    fill="none"
    role="img"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    style={{ shapeRendering: "geometricPrecision" }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="14" rx="2" ry="2" width="20" x="2" y="3" />
    <line x1="8" x2="16" y1="21" y2="21" />
    <line x1="12" x2="12" y1="17" y2="21" />
  </svg>
);

/**
 * CheckIcon for indicating selected options
 */
export const CheckIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden="true"
    className={cn(className, "text-current")}
    fill="none"
    role="presentation"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <title>Selected option</title>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
